/**
 * Dynamic CSS Variable Handler
 */

class BrowserVars {
  constructor(element) {
    this.element = element;
    this.mouseMove = this.mouseMove.bind(this);
    this.pageScroll = this.pageScroll.bind(this);
    this.connect();
  }

  connect() {
    document.body.addEventListener('mousemove', this.mouseMove);
    window.addEventListener('scroll', this.pageScroll);
  }

  disconnect() {
    document.body.removeEventListener('mousemove', this.mouseMove);
    window.removeEventListener('scroll', this.pageScroll);
  }

  mouseMove(evt) {
    const root = document.documentElement;
    root.style.setProperty('--mouse-x', `${evt.clientX}px`);
    root.style.setProperty('--mouse-y', `${evt.clientY}px`);
  }

  pageScroll() {
    const root = document.documentElement;
    root.style.setProperty('--scroll-y', `${window.scrollY}px`);
  }
}

export default BrowserVars; 